import React, { useRef, useState, useEffect } from 'react'
import './hideOrderCategory.css'
import firebase from '../../../../config/fbConfig'
import arrowRight from './../../../assets/rightArrow.png'
import arrowLeft from './../../../assets/rightArrow.png'

const db = firebase.firestore();

function HideOrderCategory(props) {

    let [hiddenCategories, setHiddenCategories] = useState([])
    let [unhiddenCategories, setUnhiddenCategories] = useState([])
    const forceUpdate = React.useState()[1].bind(null, {})
    const lastClicked = useRef({ elem: null, category: null, index: null }) // elem storing the last clicked element, category stores the obj of last clicked, index stores the index of last clicked

    useEffect(() => {
        const clonedMenu = JSON.parse(JSON.stringify(props.menu))
        setHiddenCategories(clonedMenu.filter(value => value.isHidden));
        setUnhiddenCategories(clonedMenu.filter(value => !value.isHidden));
    }, [])

    let handleLast = (targ, category, index) => {
        if (lastClicked.current.elem !== null) {
            lastClicked.current.elem.style.background = 'none';
        }
        lastClicked.current.elem = targ;
        targ.style.background = "#c5c5c5";
        lastClicked.current.category = category;
        lastClicked.current.index = index;
    }

    let moveToHidden = (elem, categoryObj, index) => {
        if (elem === null) return;
        // If coming from UNHIDDEN, so allow to it move HIDDEN
        if (elem.parentNode.parentNode.dataset.source === "unhidden") {
            categoryObj.isHidden = true;

            unhiddenCategories.splice(index, 1);
            setUnhiddenCategories(unhiddenCategories);

            hiddenCategories.push(categoryObj);
            setHiddenCategories(hiddenCategories);

            lastClicked.current = { elem: null, category: null, index: null };
            forceUpdate();
        }
    }

    let moveToUnhidden = (elem, categoryObj, index) => {
        if (elem === null) return;
        // If coming from HIDDEN, so allow to it move UNHIDDEN
        if (elem.parentNode.parentNode.dataset.source === "hidden") {
            categoryObj.isHidden = false;

            hiddenCategories.splice(index, 1);
            setHiddenCategories(hiddenCategories);

            unhiddenCategories.push(categoryObj);
            setUnhiddenCategories(unhiddenCategories);

            lastClicked.current = { elem: null, category: null, index: null };
            forceUpdate();
        }
    }

    let ExecuteChange = () => {
        if (window.location.href.includes('/en')) {
            if (!window.confirm(`Are you sure you want to apply these changes?`)) return;
        } else {
            if (!window.confirm(`האם אתה בטוח שברצונך להחיל את שינויים אלו?`)) return;
        }

        let newArr = unhiddenCategories.concat(hiddenCategories); // first Unhidden categories, then hidden 

        // Because props are immutable, and I don't want to use state lol, so I gotta iterate this loop and change props.menu accordingly
        for (let i = 0; i < props.menu.length; i++) {
            props.menu[i] = newArr[i];
        }

        let categoryLang = 'categories' + props.chosenLang;
        db.collection('menu').doc('categories').update({
            [categoryLang]: props.menu
        });
        if (window.location.href.includes('/en')) {
            alert("Successfully changed!");
        } else {
            alert("שונה בהצלחה!");
        }

    }

    if (window.location.href.includes('/en')) {
        return (
            <div id="hideCategory">
                <div className="middleWrapper">
                    <label>Click on a category to change its position</label>
                    <div id="inGridWrapper">
                        <div className="boxIngrid">
                            <div>Hidden Categories</div>
                            <ul data-source="hidden">
                                {hiddenCategories.map((category, index) =>
                                    <li key={category.title}><div onClick={(e) => handleLast(e.target, category, index)}>{category.title}</div></li>
                                )}
                            </ul>
                        </div>

                        <img className="arrows" id="arrowLeft" src={arrowLeft} onClick={() => moveToHidden(lastClicked.current.elem, lastClicked.current.category, lastClicked.current.index)} />
                        <img className="arrows" id="arrowRight" src={arrowRight} onClick={() => moveToUnhidden(lastClicked.current.elem, lastClicked.current.category, lastClicked.current.index)} />

                        <div className="boxIngrid">
                            <div>Unhidden Categories</div>
                            <ul data-source="unhidden">
                                {unhiddenCategories.map((category, index) =>
                                    <li key={category.title}><div onClick={(e) => handleLast(e.target, category, index)}>{category.title}</div></li>
                                )}
                            </ul>
                        </div>
                    </div>
                    <button id="mainButton" onClick={(e) => ExecuteChange()}>Save Changes</button>
                </div>
            </div>
        )
    }

    return (
        <div id="hideCategory" className="hebrew">
            <div className="middleWrapper">
                <label>לחץ על קטגוריה כדי לשנות את המיקום שלה</label>
                <div id="inGridWrapper">
                    <div className="boxIngrid">
                        <div>קטגוריות מוסתרות</div>
                        <ul data-source="hidden">
                            {hiddenCategories.map((category, index) =>
                                <li key={category.title}><div onClick={(e) => handleLast(e.target, category, index)}>{category.title}</div></li>
                            )}
                        </ul>
                    </div>

                    <img className="arrows" id="arrowLeft" src={arrowLeft} onClick={() => moveToHidden(lastClicked.current.elem, lastClicked.current.category, lastClicked.current.index)} />
                    <img className="arrows" id="arrowRight" src={arrowRight} onClick={() => moveToUnhidden(lastClicked.current.elem, lastClicked.current.category, lastClicked.current.index)} />

                    <div className="boxIngrid">
                        <div>קטגוריות גלויות</div>
                        <ul data-source="unhidden">
                            {unhiddenCategories.map((category, index) =>
                                <li key={category.title}><div onClick={(e) => handleLast(e.target, category, index)}>{category.title}</div></li>
                            )}
                        </ul>
                    </div>
                </div>
                <button id="mainButton" onClick={(e) => ExecuteChange()}>שמור שינויים</button>
            </div>
        </div>
    )
}

export default HideOrderCategory
